<template>
  <div>
    <Header />

    <div v-if="loading" class="content-web container mt-5 mb-5 ip-detail">
      <div class="text-center" style="width: 100%; padding-top: 50px;">
        <div class="spinner-border text-dark" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else class="content-web">
      <div class="container mt-5 mb-5 ip-detail">
        <div class="row">
          <!-- <div class="col-12">
            <div class="ip-type">{{idea.typeName}}</div>
          </div>-->
          <div class="col-12 cttv">
            <div class="title">
              <span class="info">{{ idea.companyName }}</span>
              <span class="info">{{idea.type | GetTypeName}}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="ip-detail-top clearfix">
              <div class="row">
                <div class="col-sm-12 col-md-8 col-lg-8 d-flex mb-3">
                  <div class="author-info">
                    <div class="name row">
                      <div class="col-12">
                        <h2 style="cursor: pointer; word-break: break-word;">{{idea.title}}</h2>
                      </div>
                    </div>
                    <div class="author-info-btm row mt-2">
                      <div class="col-12">
                        <strong class="mr-1">Tác giả/Nhóm tác giả:</strong>
                        {{idea.author}}
                        <div>
                          <strong class="mr-1">Liên hệ:</strong>
                          {{idea.contactName}}
                          &nbsp;&nbsp;
                          <strong
                            class="mr-1"
                          >SĐT:</strong>
                          {{idea.contactPhone}}
                          &nbsp;&nbsp;
                          <strong
                            class="mr-1"
                          >Email:</strong>
                          {{idea.contactEmail}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 d-flex ip-count mb-3">
                  <div class="medal">
                    <div>iKHIEN</div>
                    <img :src="getImageMedal(idea)" />
                  </div>
                  <div class="views">
                    <div>VIEWS</div>
                    <span class="count">{{ idea.totalView || 0}}</span>
                  </div>
                  <div class="rate">
                    <div>RATE</div>
                    <span class="d-flex">
                      <span class="count">{{rating.avgRate | digit1}}</span>
                      <div class="d-flex">
                        <VueRatingIt
                          class="rating"
                          :total="5"
                          :score="rating.avgRate"
                          @rating="onRating"
                          size="12px"
                          :disabled="isDisabledVote"
                        ></VueRatingIt>
                        <div class="small">({{rating.totalVote || 0}} votes)</div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-5 mb-5 content-detail">
        <div class="row">
          <div class="col-12">
            <vue-tabs>
              <v-tab title="Overview">
                <div class="tab-body introduction mt-3">
                  <div class="title">THÔNG TIN TỔNG QUÁT</div>

                  <div class="sub-title">
                    Giới thiệu về sáng kiến:
                    <p v-html="breakNewLine(idea.intro)" ></p>
                  </div>
                  <div class="sub-title">
                    Đơn vị:
                    <p>{{idea.companyUnit}}</p>
                  </div>
                  <div class="sub-title">
                    Phòng/ban:
                    <p>{{idea.companyDepartment}}</p>
                  </div>
                  <div class="sub-title">
                    Thời điểm áp dụng thực tế:
                    <p>{{idea.applyDate | FormatDateTime}}</p>
                  </div>
                </div>
                <div class="tab-body introduction">
                  <div class="title">NỘI DUNG SÁNG KIẾN</div>
                  <div class="sub-title">
                    Tình trạng trước khi có sáng kiến:
                    <p v-html="breakNewLine(idea.statusBefore)" ></p>
                  </div>
                  <div class="sub-title">
                    Mục đích của giải pháp:
                    <p v-html="breakNewLine(idea.solutionPurpose)" ></p>
                  </div>
                  <div class="sub-title">
                    Nội dung giải pháp đề nghị công nhận sáng kiến:
                    <p v-html="breakNewLine(idea.ideaSuggestApplyContent)" ></p>
                  </div>
                </div>
                <div class="tab-body introduction">
                  <div class="title">PHÂN TÍCH SÁNG KIẾN</div>
                  <div class="sub-title">
                    Tính hiệu quả:
                    <p v-html="breakNewLine(idea.effective)" ></p>
                  </div>
                  <div class="sub-title">
                    Tính mới:
                    <p v-html="breakNewLine(idea.novelty)" ></p>
                  </div>
                  <div class="sub-title">
                    Tính sáng tạo:
                    <p v-html="breakNewLine(idea.creativity)" ></p>
                  </div>
                  <div class="sub-title">
                    Dự định tiếp theo:
                    <p v-html="breakNewLine(idea.nextPlan)" ></p>
                  </div>
                </div>
                <div class="tab-body introduction">
                  <div class="title">THÔNG TIN KHÁC</div>
                  <div class="sub-title">
                    Các thông tin cần được bảo mật:
                    <p v-html="breakNewLine(idea.securityContent)" ></p>
                  </div>
                  <div class="sub-title">
                    Các điều kiện cần thiết để áp dụng sáng kiến:
                    <p v-html="breakNewLine(idea.ideaCondition)" ></p>
                  </div>
                  <div class="sub-title">File đính kèm:</div>
                  <div v-if="attachmentDetail && attachmentDetail.length" class="content">
                    <a
                      v-for="file in attachmentDetail"
                      :key="file.id"
                      class="badge badge-attachment"
                      style="margin-right: 20px; cursor: pointer;"
                      @click="downloadAttachment(file,idea.id)"
                    >{{file.fileName}}</a>
                  </div>

                  <div class="content" v-else>Không có dữ liệu tại thời điểm này!</div>
                </div>

                <div class="tab-body introduction">
                  <div class="title">SLIDESHOW</div>
                  <div v-if="idea.slideShow">
                    <VueSlickCarousel height="200px">
                      <img
                        v-for="thumbnail in getSlideShows()"
                        :key="thumbnail"
                        :src="apiUrl + '/image/' + thumbnail"
                      />
                    </VueSlickCarousel>
                  </div>
                </div>
              </v-tab>
              <v-tab
                title="Comment"
                id="commentTab"
                v-if="idea.status != 'submit' && idea.status != 'draft'"
              >
                <comment-list></comment-list>
              </v-tab>
            </vue-tabs>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import "vue-nav-tabs/themes/vue-tabs.css";

import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import { VueTabs, VTab } from "vue-nav-tabs";
import axios from "axios";
import VueRatingIt from "vue-rating-it";
import VueSlickCarousel from "vue-slick-carousel";

import * as CONFIG from "../../config/index";

import CommentList from "@/components/common/CommentList";
import ideaCommon from "../../common/idea";
import ratingCommon from "../../common/rating";
import { ipType } from "../const/ipType";
import helper from "../../common/helper";
import { getFileInfoList } from "../../common/file";
import moment from "moment";

export const DOWNLOAD_FILE_API_URL = `${CONFIG.API_URL}/file/download`;

const handleIPError = function(error) {
  if (error.response.status === 403) {
    window.location.href = `${CONFIG.CLIENT_URL}/#/not-found`;
  }
};

export default {
  name: "IPView",
  components: {
    Header,
    Footer,
    VueTabs,
    VTab,
    CommentList,
    VueRatingIt,
    VueSlickCarousel
  },
  data() {
    return {
      apiUrl: CONFIG.API_URL,
      idea: {},
      loading: false,
      rating: {
        avgRate: 0,
        totalVote: 0
      },
      isDisabledVote: true,
      attachmentDetail: null
    };
  },
  filters: {
    digit1(num) {
      if (num) {
        return num.toFixed(1);
      }
      return 0;
    },
    GetTypeName(code) {
      if (!code) {
        return "";
      }
      const typeData = ipType.find(p => p.code === code);
      if (typeData) {
        return typeData.name;
      }
      return "";
    },
    FormatDateTime: function(time) {
      if (time != null) {
        return moment(time).format("YYYY-MM-DD");
      }
      return "";
    }
  },

  async mounted() {
    this.getIdea();
    this.loading = false;
    ideaCommon.totalViewIp(this.$route.params.id);
  },
  methods: {
    getIdea() {
      this.loading = true;
      ideaCommon
        .getIdea(this.$route.params.id)
        .then(res => {
          this.idea = res;
          this.getAttachments();
          if (this.idea.status != "submit" && this.idea.status != "draft") {
            this.getRating();
            this.getUserRated();
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    getImageMedal(idea) {
      try {
        if (!idea.medal && !idea.yearReward) {
          return "";
        }

        if(idea.yearReward){
           return require(`@/assets/images/medals/${idea.yearReward}.png`);
        } else {
          return require(`@/assets/images/medals/${idea.medal}.png`);
        }
      } catch (error) {
        return "";
      }
    },
    async getAllCompany() {
      try {
        let res = await axios.get(
          CONFIG.API_URL + "/company/search?pageNo=1&pageSize=1000"
        );
        return res.data.data.items;
      } catch (e) {
        console.error(e);
      }
    },
    async onRating(rating) {
      if (!this.idea || !this.idea.id) {
        return;
      }
      try {
        await ratingCommon.ratingIP(this.idea.id, rating);
        await this.getRating();
        await this.getUserRated();
        helper.successMsg("Rating Success !");
      } catch (err) {
        helper.errMsg("Rating Error");
      }
    },
    async getRating() {
      if (!this.idea || !this.idea.id) {
        return;
      }
      const result = await ratingCommon.getRating(this.idea.id);
      this.rating = result;
    },
    async getUserRated() {
      if (!this.idea || !this.idea.id) {
        return;
      }
      const result = await ratingCommon.getUserRated(this.idea.id);
      if (result && result > 0) {
        this.isDisabledVote = true;
      } else {
        this.isDisabledVote = false;
      }
    },
    async getAttachments() {
      const { attachments } = this.idea;
      if (attachments) {
        this.attachmentDetail = await getFileInfoList(attachments);
      }
    },
    getSlideShows() {
      const { slideShow } = this.idea;
      if (slideShow) {
        return slideShow.split(",");
      }
      return [];
    },
    downloadAttachment(file, contentId) {
      this.axios
        .get(`${DOWNLOAD_FILE_API_URL}?id=${file.id}&contentId=${contentId}`, {
          responseType: "blob"
        })
        .then(res => {
          const headers = res.headers;
          const blob = new Blob([res.data], { type: headers["content-type"] });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = file.fileName;
          link.click();
        })
        .catch(err => {
          this.$notify({
            group: "notify",
            type: "error",
            title: "Bạn không có quyền tải về file này!"
          });
        });
    },
    breakNewLine(content) {
      return helper.breakLine(content);
    }
  }
};
</script>

<style scoped>
.ip-detail {
  color: #676a6c;
}

.ip-type {
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.06px;
  text-align: left;
  display: inline-block;
}

.ip-description {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
}

.content {
  overflow-wrap: break-word;
  max-width: 80vw;
}

.ip-detail-top {
  box-shadow: 0 16px 34px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  padding: 15px 0;
}

.author-info {
  margin: 5px 0 0 15px;
}

.author-info .name h2 {
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.06px;
  text-align: left;
  display: inline-block;
  color: #1e242f;
  font-size: 26px;
  margin: 0;
  font-weight: bold;
  color: #337ab7;
}

.vue-tabs {
  width: 100%;
}

.tab-body .title {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 14px;
}
.tab-body .sub-title {
  max-width: 100%;
  font-weight: 600;
  font-size: 14px;
}

.tab-body {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
}

.badge-list {
  display: flex;
  align-content: center;
}

.badge-item {
  font-size: 12px;
  font-weight: 650;
  padding: 5px 10px;
  margin-top: 2px;
  line-height: 1.6;
  border-radius: 2px;
  background-color: #d1dade;
  color: #5e5e5e;
  cursor: pointer;
}

.update-version-detail .date-update {
  width: 100%;
  height: 38px;
  font-size: 28px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.14px;
  text-align: left;
  color: #1e242f;
  margin-top: 20px;
  margin-bottom: 10px;
}

.update-version-detail .content-update {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
  word-break: break-word;
}

.update-version-detail .version-update {
  font-size: 18px;
  color: #3199bb;
  font-weight: 600;
  letter-spacing: 0.14px;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  margin-top: 5px;
  cursor: pointer;
}

.tab-body p {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
  margin-left: 15px;
}
.ip-count > div > div {
  font-weight: bold;
  font-size: 16px;
  color: #1e242f;
}

.ip-count > div span.count {
  color: #3299ba;
  font-size: 28px;
  font-weight: 600;
}

.ip-count > div {
  margin: 0 7px;
}

.medal img,
.views .count {
  margin: auto;
  display: block;
  text-align: center;
}
.medal img {
  margin-top: 8px;
  width: 50px;
}

.cttv .title {
  color: #337ab7;
  font-weight: bold;
}

.cttv .info {
  color: #fff;
  background-color: #3199bb;
  border-radius: 5px;
  padding: 0 5px;
}

.rate .count {
  color: #e07254 !important;
}

.rate .d-flex {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.rate .d-flex .d-flex {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-left: 5px;
}

.rate .d-flex .d-flex .small {
  font-size: 11px;
  color: #e07254;
  font-weight: 600;
}

.slick-slider img {
  display: block;
  max-width: 100%;
  width: auto;
  height: auto;
  height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/IPView.vue